import React from 'react'
import { TrashIcon } from 'components/vectors';
import PropTypes from 'prop-types'



const Artiste = props=> { 
    const {name, imageUrl, occupation, numberOfSongs, hideTrash } = props;
    return (
        <div className="artiste-card">
            <img className="artiste-image" src={imageUrl} alt="artiste" />
            <div className="artiste-card__bottom">
                <h5 className="text--medium text--black">{name}</h5>
                <div className="d-flex flex-row justify-content-between">
                    <p className="text--small text--grey">{occupation}</p>
                    {
                        numberOfSongs ? <p className="text--small-bold text--light-blue">{numberOfSongs} Songs</p> : hideTrash ? null : <TrashIcon />
                    }
                </div>
            </div>
        </div>
    )
}

Artiste.prototype = {
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    occupation: PropTypes.string.isRequired,
    numberOfSongs: PropTypes.string
}

export default Artiste;